import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  class: "text-left text-truncate",
  style: {"max-width":"100px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = {
  key: 1,
  style: {"color":"gray"}
}
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { style: {"width":"750px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn_remove_icon = _resolveComponent("v-btn-remove-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, { class: "default_card_wm elevation-0 px-4 py-3 mb-2" }, {
      default: _withCtx(() => [
        (!_ctx.componentForAlreadyDeclaredItems)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              "no-gutters": "",
              class: "d-flex justify-space-between align-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_icon, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDataTable = !_ctx.showDataTable)),
                      icon: _ctx.showDataTable ? '$fa-chevron-up' : '$fa-chevron-down'
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "8" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.fromAssistVATComponent
                                ? "Flux bancaires lettrés de la période déclarée"
                                : "Flux bancaires non lettrés"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "d-flex justify-end"
                }, {
                  default: _withCtx(() => [
                    (_ctx.fromAssistVATComponent)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          rounded: "",
                          size: "small",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleNewManualRowDialog())),
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode(" Ajouter une ligne ")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.vatItems && _ctx.vatItems.length)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          rounded: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.vatDeclarationAlreadyDone())),
                          disabled: _ctx.disabledVatDeclararionAlreadyDone,
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode(" Déclaration de TVA déjà réalisée ")
                          ])),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isGrossAmountExceeded)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              "no-gutters": "",
              style: {"color":"red"}
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("La somme des montants TTC des sous-éléments d'un flux dépasse le montant TTC du flux initial.")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showDataTable)
          ? (_openBlock(), _createBlock(_component_v_data_table, {
              key: 2,
              class: "table rounded-xl pa-2",
              headers: _ctx.headers,
              items: _ctx.sortedVatItems,
              "item-key": 'key',
              striped: true,
              dense: true,
              fixedHeader: true,
              "row-height": "50px",
              itemsPerPage: -1,
              "hide-default-footer": true
            }, _createSlots({
              item: _withCtx((props) => [
                (_openBlock(), _createElementBlock("tr", {
                  key: props.item.bankTransactionId
                }, [
                  _createElementVNode("td", null, [
                    (!props.item.isSubItem && !_ctx.componentForAlreadyDeclaredItems)
                      ? (_openBlock(), _createBlock(_component_v_checkbox, {
                          key: 0,
                          modelValue: _ctx.selectedVatItemIds,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedVatItemIds) = $event)),
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.emptyFunction()), ["stop"])),
                          value: props.item.bankTransactionId,
                          color: "primary",
                          "hide-details": "",
                          disabled: !props.item.bankTransactionId
                        }, null, 8, ["modelValue", "value", "disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    (
                                    !props.item.isSubItem &&
                                    props.item.bankTransactionId &&
                                    !['Import', 'Intracom', 'Export', 'NoVat'].includes(
                                        props.item.type,
                                    ) &&
                                    !_ctx.componentForAlreadyDeclaredItems
                                )
                      ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                          key: 0,
                          icon: props.item.hasBeenSplitted ? '$add' : '$fa-cut',
                          size: "small",
                          onClick: ($event: any) => (_ctx.splitAssistItem(props.item))
                        }, null, 8, ["icon", "onClick"]))
                      : _createCommentVNode("", true),
                    (
                                    (props.item.isSubItem || !props.item.bankTransactionId) &&
                                    !_ctx.componentForAlreadyDeclaredItems
                                )
                      ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                          key: 1,
                          icon: "$oss-trash",
                          size: "small",
                          onClick: ($event: any) => (_ctx.deleteSubOrAddedItem(props.item))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_1, [
                    (!props.item.isSubItem)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.item.displayDate), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_3, [
                    (!props.item.isSubItem)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createTextVNode(_toDisplayString(props.item.wording) + " ", 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item
                                        .toDisplayAccountableAccounts, (aaName, index) => {
                            return (_openBlock(), _createBlock(_component_v_chip, {
                              key: index,
                              label: "",
                              variant: "outlined",
                              size: "x-small",
                              color: props.item.getAccountableAccountColor(aaName)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(aaName), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"]))
                          }), 128)),
                          _createTextVNode(" " + _toDisplayString(props.item.thirdParties), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    (!props.item.isSubItem)
                      ? (_openBlock(), _createBlock(_component_v_select_filled, {
                          key: 0,
                          modelValue: props.item.type,
                          "onUpdate:modelValue": [($event: any) => ((props.item.type) = $event), ($event: any) => (_ctx.applyType(props.item))],
                          items: _ctx.vatTypes,
                          "item-title": "name",
                          "item-value": "value",
                          "hide-details": "",
                          density: "compact",
                          class: "custom-field-input-vat",
                          disabled: 
                                    props.item.hasBeenSplitted || _ctx.componentForAlreadyDeclaredItems
                                
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_5, [
                    (!props.item.hasBeenSplitted)
                      ? (_openBlock(), _createBlock(_component_v_select_filled, {
                          key: 0,
                          modelValue: props.item.computedVatRate,
                          "onUpdate:modelValue": ($event: any) => ((props.item.computedVatRate) = $event),
                          items: _ctx.availableVatRates(props.item.type),
                          "item-title": "name",
                          "item-value": "value",
                          "hide-details": "",
                          disabled: 
                                    props.item.type === 'Import' ||
                                    props.item.type === 'Intracom' ||
                                    props.item.type === 'Export' ||
                                    props.item.type === 'NoVat' ||
                                    props.item.hasBeenSplitted ||
                                    _ctx.componentForAlreadyDeclaredItems
                                ,
                          density: "compact",
                          class: "custom-field-input-vat"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.item.displayGrossAmount -
                                        _ctx.getGrossAmountSum(props.item.bankTransactionId) >
                                    0
                                        ? "TTC initial : " +
                                          _ctx.newCommonFormatCurrency(
                                              props.item.displayGrossAmount,
                                              undefined,
                                          )
                                        : ""), 1))
                  ]),
                  _createElementVNode("td", _hoisted_7, [
                    (props.item.hasBeenSplitted)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(props.item.displayGrossAmount -
                                        _ctx.getGrossAmountSum(props.item.bankTransactionId) >
                                    0
                                        ? "A affecter : " +
                                          _ctx.newCommonFormatCurrency(
                                              props.item.displayGrossAmount -
                                                  _ctx.getGrossAmountSum(props.item.bankTransactionId),
                                              undefined,
                                          )
                                        : _ctx.newCommonFormatCurrency(
                                              props.item.displayGrossAmount,
                                              undefined,
                                          )), 1)
                        ], 64))
                      : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                          key: 1,
                          "hide-details": "",
                          modelValue: props.item.grossAmount,
                          "onUpdate:modelValue": ($event: any) => ((props.item.grossAmount) = $event),
                          class: "custom-field-input-vat",
                          disabled: _ctx.componentForAlreadyDeclaredItems
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                  ]),
                  _createElementVNode("td", _hoisted_8, [
                    (props.item.hasBeenSplitted)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                        _ctx.getNetAmountSum(props.item.bankTransactionId),
                                        undefined,
                                    )), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(props.item.displayNetAmount, undefined)), 1)
                        ], 64))
                  ]),
                  _createElementVNode("td", null, [
                    (props.item.vatRate === null)
                      ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                          key: 0,
                          modelValue: props.item.vatAmount,
                          "onUpdate:modelValue": ($event: any) => ((props.item.vatAmount) = $event),
                          "hide-details": "auto",
                          dense: "",
                          minifyRules: true,
                          max: props.item.grossAmount,
                          xDense: true,
                          class: "text-center"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "max"]))
                      : (props.item.hasBeenSplitted)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                        _ctx.getVatAmountSum(props.item.bankTransactionId),
                                        undefined,
                                    )), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(props.item.displayVatAmount, undefined)), 1)
                          ], 64))
                  ]),
                  _createElementVNode("td", null, [
                    (!props.item.isSubItem && !_ctx.componentForAlreadyDeclaredItems)
                      ? (_openBlock(), _createBlock(_component_v_switch, {
                          key: 0,
                          class: "mt-0",
                          modelValue: props.item.toAdd,
                          "onUpdate:modelValue": [($event: any) => ((props.item.toAdd) = $event), ($event: any) => (_ctx.applyToAdd(props.item))],
                          "hide-details": ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : (_openBlock(), _createBlock(_component_v_btn_remove_icon, {
                          key: 1,
                          onClick: ($event: any) => (_ctx.removeAlreadyDeclaredItem(props.item)),
                          style: {"transform":"scale(0.75)"}
                        }, null, 8, ["onClick"]))
                  ])
                ]))
              ]),
              _: 2
            }, [
              (_ctx.vatItems && _ctx.vatItems.length && !_ctx.componentForAlreadyDeclaredItems)
                ? {
                    name: "header.checkbox",
                    fn: _withCtx(() => [
                      _createVNode(_component_v_checkbox, {
                        ripple: false,
                        "hide-details": "",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.selectAllVatItems()), ["stop"])),
                        color: "primary",
                        "model-value": _ctx.selectedVatItemIds.length === _ctx.sourceItems.length
                      }, null, 8, ["model-value"])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["headers", "items"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.newManualRowDialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newManualRowDialog) = $event)),
      title: "Ajout d'une ligne manuelle",
      onValid: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addManualRow())),
      onClose: _cache[12] || (_cache[12] = ($event: any) => {
                _ctx.newManualRowDialog = false;
                _ctx.resetNewManualRow();
            }),
      "valid-disabled": 
                !_ctx.newManualRow.wording || !_ctx.newManualRow.vatType || !_ctx.newManualRow.grossAmount
            
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "my-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "1" }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex align-center"
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createElementVNode("b", null, "Indiquez le libellé à afficher :", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    "hide-details": "",
                    label: "Libellé",
                    outlined: "",
                    modelValue: _ctx.newManualRow.wording,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newManualRow.wording) = $event)),
                    density: "compact"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "1" })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "my-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "1" }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex align-center"
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createElementVNode("b", null, "Indiquez le type de TVA :", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    "hide-details": "",
                    outlined: "",
                    modelValue: _ctx.newManualRow.vatType,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newManualRow.vatType) = $event)),
                    items: _ctx.vatTypes,
                    "item-title": "name",
                    "item-value": "value",
                    density: "compact"
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "1" })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "my-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "1" }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex align-center"
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createElementVNode("b", null, "Indiquez le montant TTC :", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    "hide-details": "",
                    modelValue: _ctx.newManualRow.grossAmount,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newManualRow.grossAmount) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "1" })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "mt-1 mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "1" }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex align-center"
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createElementVNode("b", null, "Indiquez le taux de TVA :", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    "hide-details": "",
                    outlined: "",
                    modelValue: _ctx.newManualRow.vatRate,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newManualRow.vatRate) = $event)),
                    items: _ctx.availableVatRates(_ctx.newManualRow.vatType),
                    "item-title": "name",
                    "item-value": "value",
                    disabled: _ctx.disableVatRate,
                    density: "compact"
                  }, null, 8, ["modelValue", "items", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "1" })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "valid-disabled"])
  ]))
}